export const FollowQueryKey = {
    followers: (username: string) => ['author', username, 'followers'],
    following: (username: string) => ['author', username, 'following'],
    followCheck: (username: string) => ['follow', 'check', username],
    followStatistics: (username: string) => ['follow', 'stats', username],
}
